import React, { useEffect, useState } from "react";
import FadeInWrapper from "./fade-in-wrapper";

interface BottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  showOverlay?: boolean;
  eyebrow?: string;
  mainText?: string;
  subText?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  disableDrag?: boolean;
}

const BottomSheet: React.FC<BottomSheetProps> = ({
  isOpen,
  onClose,
  children,
  showOverlay = true,
  eyebrow,
  mainText,
  subText,
  buttonText,
  onButtonClick,
  disableDrag = false,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      document.body.style.overflow = "hidden";
      // 약간의 지연을 두어 DOM이 렌더링된 후 애니메이션 시작
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else {
      setIsVisible(false);
      document.body.style.overflow = "unset";
      // 애니메이션이 끝난 후 컴포넌트 언마운트
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!shouldRender) return null;

  return (
    <>
      {showOverlay && (
        <div
          className={`fixed inset-0 bg-black z-[60] transition-opacity duration-300 max-w-[742px] mx-auto ${
            isVisible ? "bg-opacity-50" : "bg-opacity-0"
          }`}
          onClick={onClose}
        />
      )}
      <div
        className={`fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl z-[70] shadow-lg transform transition-all duration-300 max-w-[742px] mx-auto ${
          isVisible ? "translate-y-0" : "translate-y-full"
        }`}
      >
        <div className="w-full flex justify-center py-2">
          <div className="w-12 h-1 bg-gray-300 rounded-full" />
        </div>
        <div className="p-4">
          {eyebrow && (
            <FadeInWrapper>
              <p className="text-sm font-semibold text-blue-500 mb-1">{eyebrow}</p>
            </FadeInWrapper>
          )}
          {mainText && (
            <FadeInWrapper>
              <h1 className="text-2xl font-bold">{mainText}</h1>
            </FadeInWrapper>
          )}
          {subText && (
            <FadeInWrapper>
              <p className="text-md text-gray-500 mt-3">{subText}</p>
            </FadeInWrapper>
          )}
          {children}
          {buttonText && (
            <button
              className="mt-4 w-full bg-blue-500 text-white font-bold py-4 px-4 rounded-xl"
              onClick={onButtonClick}
            >
              {buttonText}
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default BottomSheet;
